import { IActiveNotification, INotification } from 'shared/models/User'

export const mapNotifications = (
  all: INotification[],
  active: IActiveNotification[]
) => {
  const mapped = Array.from(all)
    .filter((x) => x.showForEditInBoardPortal)
    .map((x) => {
      x.active = active.some((y) => y.typeId === x.id)

      return x
    })
    .sort((a, b) => (a.email === b.email ? 0 : a.email ? -1 : 1))

  return mapped
}

export const getFullName = (firstName?: string, lastName?: string) => {
  if (!firstName && !lastName) return ''

  const name = `${firstName || ''} ${lastName || ''}`

  return name.trim()
}
